module.exports = __webpack_public_path__ + "media/images/games/league-of-legends/background-e07ea2dd5c01e4ed0677fccb02ad036a.jpg";